import { getIdOrNull, requestWithPromise } from '..'
import { HttpMethods } from '../apiHelper'

export const getChildren = (user, option) => {
  return requestWithPromise(
    `/api/institution-options/${getIdOrNull(option)}/children`,
    HttpMethods.GET,
    null,
    user
  )
}
